export const Constants = {
  API_SERVER: () => {
    return process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL
      : "http://localhost:8000";
  },
};
